// extracted by mini-css-extract-plugin
export var circle = "_ez-1";
export var exitConfirmationModal = "_ez-5";
export var iframe = "_ez-0";
export var offline = "_ez-3";
export var online = "_ez-2";
export var workstationSelectError = "_ez-4";